import { createClient } from "@supabase/supabase-js";

export const supabaseURL = import.meta.env.VITE_SUPABASE_URL as string;
export const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

console.log("Supabase URL:", supabaseURL);
console.log("Supabase Key:", supabaseKey);

export const supabase = createClient(supabaseURL, supabaseKey);
